/**
 * InquiryListContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import MessageAlert from 'utils';
import { InquiryApi } from 'api';
import moment from 'moment';
import InquiryListPresenter from './InquiryListPresenter';

const today = {
  start_date: moment().startOf('day').unix(),
  end_date: moment().endOf('day').unix(),
};

/**----------------------------------------
 * [Component] 총관리자: 문의목록 - 컨테이너
 * ----------------------------------------
 */
const InquiryListContainer = ({ defaultShopId, permission, FAQ = false }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentShop, setCurrentShop] = useState(defaultShopId ?? null);
  const [reviewDetailModal, setReviewDetailModal] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 문의목록 조회
   * --------------------
   */
  const handleGetInquiryList = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await InquiryApi.getInquiries({
        join_tables: `["user", "product", "inquiry_file"]`,
        ...(currentShop && { shop_information_id: currentShop }),
      });
      if (status !== 200) throw { message };

      setTimeout(() => {
        if (FAQ) {
          setData(data.filter((item) => item.inquiry_type === 'FAQ'));
        } else {
          setData(data.filter((item) => item.inquiry_type !== 'FAQ'));
        }
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 문의삭제
   * --------------------
   */
  const handleDeletedInquiry = async (key) => {
    setData(data.filter((item) => item.inquiry_id !== key));
  };

  /* ===== HOOKS ===== */
  /* 초기 설정 & 업체변경 시 반영 */
  useEffect(() => {
    handleGetInquiryList();
  }, [currentShop]);
  // useEffect(() => {
  //   currentShop && handleGetInquiryList();
  // }, [currentShop]);

  /* ===== RENDER ===== */
  return (
    <InquiryListPresenter
      {...{
        FAQ,
        loading,
        data,
        permission,
        currentShop,
        setCurrentShop,
        onSavedInquiry: handleGetInquiryList,
        onDeletedInquiry: handleDeletedInquiry,
        setLoading,
      }}
    />
  );
};

/* DF */
InquiryListContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
  FAQ: false,
};
export default InquiryListContainer;
